import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ContactBankAccountModel } from './contactbankaccount.model';
import { environment } from '../../../../environments/environment';
import { ApiResponse } from '../../../models/base';

interface ApiMessageResponse {
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class ContactBankAccountService {
  contactBankAccountList: ContactBankAccountModel[] = [];

  constructor(private http: HttpClient) {}

  addData(
    contactUid: string,
    contactBankAccount: ContactBankAccountModel
  ): Promise<ContactBankAccountModel> {
    return firstValueFrom(
      this.http.post<ApiResponse<ContactBankAccountModel>>(
        environment.apiUrl + '/contacts/' + contactUid + '/bank-accounts',
        contactBankAccount
      )
    ).then((response) => response.data);
  }

  deleteData(contactUid: string, uid: string): Promise<string> {
    return firstValueFrom(
      this.http.delete<ApiMessageResponse>(
        environment.apiUrl + '/contacts/' + contactUid + '/bank-accounts/' + uid
      )
    ).then((response) => response.message);
  }

  editData(
    contactUid: string,
    uid: string,
    contactBankAccount: ContactBankAccountModel
  ): Promise<ContactBankAccountModel> {
    return firstValueFrom(
      this.http.put<ApiResponse<ContactBankAccountModel>>(
        environment.apiUrl + '/contacts/' + contactUid + '/bank-accounts/' + uid,
        contactBankAccount
      )
    ).then((response) => response.data);
  }

  loadData(contactUid: string, uid: string): Promise<ContactBankAccountModel> {
    return firstValueFrom(
      this.http.get<ApiResponse<ContactBankAccountModel>>(
        environment.apiUrl + '/contacts/' + contactUid + '/bank-accounts/' + uid
      )
    ).then((response) => response.data);
  }

  getList(contactUid: string): Promise<ContactBankAccountModel[]> {
    return firstValueFrom(
      this.http.get<ApiResponse<ContactBankAccountModel[]>>(
        environment.apiUrl + '/contacts/' + contactUid + '/bank-accounts'
      )
    ).then((response) => response.data);
  }
}